import React, { useEffect, useState } from "react";
import axios from "axios";

const CurrentAffairs = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    title: "",
    description: "",
    youtube_link: "",
    category: "",
  });


  const role = localStorage.getItem("role");
  // decide endpoint based on role
  const endpoint =
    role === "subAdmin"
      ? `${API_BASE_URL}/subadmin/currentaffair`
      : `${API_BASE_URL}/admin/currenntaffair`;

  /* FETCH */
  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      setData(res.data.data || []);

    } catch (err) {
      alert(err.response?.data?.message || "Fetch failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* INPUT */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* SUBMIT */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (editId) {
        await axios.put(`${endpoint}/${editId}`, form, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });
      } else {
        await axios.post(endpoint, form, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });
      }

      setForm({
        title: "",
        description: "",
        youtube_link: "",
        category: "",
      });

      setEditId(null);
      fetchData();

    } catch (err) {
      alert(err.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  /* EDIT */
  const handleEdit = (item) => {
    setEditId(item._id);
    setForm({
      title: item.title,
      description: item.description,
      youtube_link: item.youtube_link || "",
      category: item.category || "",
    });
  };

  /* DELETE */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;

    await axios.delete(`${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    fetchData();
  };

  const categories = [
    "Economical",
    "Sport",
    "Political",
    "Science Tech",
    "International Event",
    "National Event",
    "General"
  ];

  return (
    <>
      {/* STYLE */}
      <style>{`
        body {
          margin: 0;
          font-family: 'Poppins', sans-serif;
          background: linear-gradient(135deg, #1e1e2f, #2a2a72);
          color: white;
        }

        .container {
          max-width: 1000px;
          margin: auto;
          padding: 20px;
        }

        .heading {
          text-align: center;
          font-size: 28px;
          margin-bottom: 25px;
        }

        .glass {
          background: rgba(255,255,255,0.08);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,0.2);
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
        }

        .form {
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 25px;
        }

        .form input, .form textarea {
          padding: 10px;
          border-radius: 8px;
          border: none;
          background: rgba(255,255,255,0.1);
          color: white;
        }

        .form input::placeholder,
        .form textarea::placeholder {
          color: #ccc;
        }

        .primary-btn {
          padding: 10px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(45deg, #ff6ec4, #7873f5);
          color: white;
          cursor: pointer;
          font-weight: bold;
          transition: 0.3s;
        }

        .primary-btn:hover {
          transform: scale(1.05);
        }

        .list {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .card {
          padding: 15px;
          transition: 0.3s;
        }

        .card:hover {
          transform: translateY(-5px);
        }

        .desc {
          color: #ddd;
        }

        .meta {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          color: #aaa;
        }

        .yt-link {
          color: #ff6ec4;
          display: block;
          margin: 10px 0;
          text-decoration: none;
        }

        .actions {
          display: flex;
          gap: 10px;
        }

        .edit-btn {
          background: #4facfe;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          color: white;
          cursor: pointer;
        }

        .delete-btn {
          background: #ff4b5c;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          color: white;
          cursor: pointer;
        }

        .loading {
          text-align: center;
          margin: 10px;
        }
      `}</style>

      {/* UI */}
      <div className="container">
        <h2 className="heading">✨ Current Affairs Manager</h2>

        <form onSubmit={handleSubmit} className="form glass">
          <input name="title" value={form.title} onChange={handleChange} placeholder="Title" required />

          <textarea name="description" value={form.description} onChange={handleChange} placeholder="Description" required />

          <input name="youtube_link" value={form.youtube_link} onChange={handleChange} placeholder="YouTube Link" />

          {/* ✅ CATEGORY DROPDOWN */}
          <select
            name="category"
            value={form.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>
            {categories.map((cat, index) => (
              <option key={index} value={cat}>
                {cat}
              </option>
            ))}
          </select>


          <button type="submit" className="primary-btn">
            {editId ? "Update 🚀" : "Add 🚀"}
          </button>
        </form>

        {loading && <p className="loading">Loading...</p>}

        <div className="list">
          {data.map((item) => (
            <div key={item._id} className="card glass">
              <h3>{item.title}</h3>
              <p className="desc">{item.description}</p>

              <div className="meta">
                <span>🏷 {item.category}</span>
                <span>
                  📅 {new Date(item.date).toLocaleDateString('en-GB')}
                </span>
              </div>

              {item.youtube_link && (
                <a href={item.youtube_link} target="_blank" rel="noreferrer" className="yt-link">
                  ▶ Watch Video
                </a>
              )}

              <div className="actions">
                <button onClick={() => handleEdit(item)} className="edit-btn">Edit</button>
                <button onClick={() => handleDelete(item._id)} className="delete-btn">
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CurrentAffairs;